import i18n from '../../language/index'
import {create_title} from './../../base/titleData'
import pageData from './../../base/pageData'

export default {
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%'
  },
  mb_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%'
  },
  pc_widgets_infor: {
    showContent: ['date', 'author', 'type', 'firstAndNext','source','click'], // 显示内容
    // title: 'default', // 标题
    share: 'open', // 分享open,closed
    shareDisplayStyle: 'default',
    shareType: ['weixin', 'weibo', 'qq'],
    enShareType: ['twitter','wechat','facebook','linkedin'],
    titleStyle: {
      radio_val: 'default',
      default: {
        fsItalics: 'normal',
        fontUnderline: 'none',
        fsWeight: '700',
        fontSize: 24,
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial',
        textAlign: 'left',
        pattern: 'pure_color',
        linear_gradient: {
          start_color: 'rgba(156,40,177,1)',
          end_color: 'rgba(0, 0, 0,1)',
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      },
      custom: {
        fsItalics: 'normal', //
        fontUnderline: 'none', //
        fontSize: 24, //
        fsWeight: '700', //
        fontColor: 'rgba(51,51,51,1)',
        fontFamily: 'Arial', //
        textAlign: 'left', //
        pattern: 'pure_color', //
        linear_gradient: {
          start_color: 'rgba(156,40,177,1)',
          end_color: 'rgba(0, 0, 0,1)',
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        }
      }
    },
    showContentOptions: [{
      label: i18n.t('widgets_basic_article_info_edit_346'),
      value: 'date'
    }, {
      label: i18n.t('widgets_basic_article_info_edit_347'),
      value: 'author'
    }, {
      label: i18n.t('widgets_basic_article_info_edit_348'),
      value: 'type'
    }, {
      label: i18n.t('widgets_basic_article_info_edit_349'),
      value: 'firstAndNext'
    }, {
      label: i18n.t('widgets_basic_article_info_edit_350'),
      value: 'source'
    }, {
      label: i18n.t('widgets_basic_article_info_edit_351'),
      value: 'click'
    }],
    moduleStyle:0,
  },
  mb_widgets_infor: {},
  listArr: {
    // moduleStyle: 0   // 因为某些原因，这个字段换一个地方
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_article_info/style.js